import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import RelatedContactList from "../../../../RelatedContact/RelatedContactList";
import { GenrealInfo } from "./ContactData.styled";

const ContactData = (props) => {
  const { t, id, companyId, countryId } = props;

  return (
    <GenrealInfo>
      <RelatedContactList
        entityType="center_product"
        entityId={id}
        companyId={companyId}
        countryId={countryId}
        headerNotRequired
        columnList={[
          "ID",
          "CONTACT_COMPANY",
          "CONTACT_NAME",
          "CONTACT_FUNCTION",
          "CONTACT_TYPE",
          "CONTACT_COMMUNICATION",
          "ACTIONS",
        ]}
        dependancies={JSON.stringify(["roles", "linkedEntities"])}
      />
    </GenrealInfo>
  );
};

ContactData.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  companyId: PropTypes.number,
  countryId: PropTypes.number,
};

ContactData.defaultProps = {
  companyId: null,
  countryId: null,
};

export default withTranslation()(ContactData);
